<mat-sidenav-container>
  <mat-sidenav
    #sidenav="matSidenav"
    opened="true"
    class="mat-elevation-z8 card-background-color"
    ngClass.lt-md="card-background-color-lt-md"
  >
    <div fxaLayout="row" fxLayoutAlign="start" class="title-text-margin">
      <img src="../../assets/images/logo.png" alt="Foodism Logo" class="logo" />
    </div>
    <!-- Show Role Is Deactivate -->
    <ng-container *ngIf="roleStatus?.role.status == 0">
      <button
        mat-button
        class="menu-button"
        routerLink="/admin/dashboard"
        routerLinkActive="active-list-item"
      >
        <div fxLayout="row" fxLayoutAlign="center center">
          <img src="../../../assets/images/icons/dashboard.png" />&nbsp;
          Dashboard
        </div>
      </button>
    </ng-container>
    <!-- Role Is Active -->
    <ng-container *ngIf="roleStatus?.role.status == 1">
      <div fxLayout="column" fxLayoutGap="10px" class="foodism-menu">
        <mat-nav-list>
          <!-- Sidebar Menu -->
          <span *ngFor="let item of menuItems">
            <span *ngIf="item.children && item.children.length > 0">
              <mat-accordion>
                <mat-expansion-panel *ngIf="hasPermission('notification_view')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <button
                        mat-button
                        class="menu-button"
                        routerLinkActive="active-list-item"
                      >
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <img src="{{ item.iconName }}" />&nbsp;
                          {{ item.displayName }}
                        </div>
                      </button>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <span *ngFor="let child of item.children">
                    <mat-list-item>
                      <button
                        mat-button
                        class="menu-button-children"
                        routerLink="{{ child.route }}"
                        routerLinkActive="active-list-item"
                        [routerLinkActiveOptions]="{ exact: true }"
                      >
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <img src="{{ child.iconName }}" />&nbsp;
                          {{ child.displayName }}
                        </div>
                      </button>
                    </mat-list-item>
                  </span>
                </mat-expansion-panel>
              </mat-accordion>
            </span>
            <span *ngIf="!item.children || item.children.length === 0">
              <ng-container *ngIf="currentUserName != 'super_admin'">
                <mat-list-item
                  *ngIf="hasPermission(item.role) || item.role == ''"
                >
                  <button
                    mat-button
                    class="menu-button"
                    routerLink="{{ item.route }}"
                    routerLinkActive="active-list-item"
                  >
                    <div fxLayout="row" fxLayoutAlign="center center">
                      <img src="{{ item.iconName }}" />&nbsp;
                      {{ item.displayName }}
                    </div>
                  </button>
                </mat-list-item>
              </ng-container>

              <ng-container *ngIf="currentUserName == 'super_admin'">
                <mat-list-item>
                  <button
                    mat-button
                    class="menu-button"
                    routerLink="{{ item.route }}"
                    routerLinkActive="active-list-item"
                  >
                    <div fxLayout="row" fxLayoutAlign="center center">
                      <img src="{{ item.iconName }}" />&nbsp;
                      {{ item.displayName }}
                    </div>
                  </button>
                </mat-list-item>
              </ng-container>
            </span>
          </span>
        </mat-nav-list>
      </div>
    </ng-container>
    <div fxLayoutGap="10px" class="logout-button-sec">
      <button mat-button class="logout-button" (click)="logout()">
        <span>Logout</span>
      </button>
    </div>
  </mat-sidenav>
  <!-- Sidebar dark mode -->
  <mat-sidenav-content [ngClass]="{ 'dark-theme': darkMode }">
    <mat-toolbar
      ngClass.lt-md="border-bottom-toolbar-display"
      color="primary"
      [ngClass]="{ 'dark-theme': darkMode }"
    >
      <button
        mat-icon-button
        *ngIf="sidenav.mode === 'over'"
        (click)="sidenav.toggle()"
      >
        <mat-icon class="color-primary" *ngIf="!sidenav.opened">
          menu
        </mat-icon>
        <mat-icon class="color-primary" *ngIf="sidenav.opened">
          close
        </mat-icon>
      </button>

      <div
        fxlayout="row"
        class="toolbar-contain full-width border-bottom-toolbar"
        [ngClass]="{ 'dark-theme': darkMode }"
        ngClass.lt-md="border-bottom-toolbar-md"
        fxLayoutAlign="center center"
      >
        <span fxHide.xs class="fileter-width">
          <span class="mat-h1 b-color"></span>
        </span>

        <div
          fxLayout="row"
          fxFlex=""
          fxLayoutAlign="space-between center"
          fxLayoutGap="10px"
          class="mb-5"
        >
          <div></div>
          <div fxLayoutAlign="end center">
            <div
              class="mr-10 notification-icon"
              fxLayoutAlign="center center"
              (click)="openNotificationDialog()"
              *ngIf="
                userPermissions?.includes('notification_view') ||
                (authService.isAdmin$ | async)
              "
            >
              <mat-icon>notifications_active</mat-icon>
              <span class="badge">{{
                notificationCount > 99 ? "99+" : notificationCount
              }}</span>
            </div>
            <div
              (click)="toggleTheme()"
              style="margin-right: 10px"
              fxLayoutAlign="center center"
            >
              <mat-icon *ngIf="!darkMode" matTooltip="Dark Mode"
                >brightness_high</mat-icon
              >
              <mat-icon *ngIf="darkMode" matTooltip="Light Mode"
                >brightness_low</mat-icon
              >
            </div>
            <div
              (click)="openFullscreen()"
              *ngIf="!isFullScreen"
              fxLayoutAlign="center center"
            >
              <!-- fullscreen -->
              <mat-icon title="Go Fullscreen">fullscreen</mat-icon>
            </div>
            <div
              (click)="exitFullscreen()"
              *ngIf="isFullScreen"
              fxLayoutAlign="center center"
            >
              <!-- exit Fullscreen -->
              <mat-icon
                [ngClass]="{ active: isFullScreen }"
                title="Exit Fullscreen"
                >fullscreen_exit</mat-icon
              >
            </div>

            <div
              class="profile-name cursor"
              fxLayout="row"
              fxFlex=""
              fxLayoutAlign="end center"
              fxLayoutGap="10px"
              (click)="openDialog()"
              *ngIf="!isLoading && currentUser"
            >
              <div class="round">
                <img
                  src="https://prod-foodism.s3.ap-south-1.amazonaws.com/{{
                    currentUser.profile_pic
                  }}"
                  onerror="this.style.display='none';"
                />
                <span *ngIf="!currentUser.profile_pic">{{ userName }}</span>
              </div>
              <div
                data-v-46d32ae8=""
                class="q-item__section column q-item__section--main justify-center"
              >
                <div data-v-46d32ae8="" class="q-item__label ellipsis">
                  <strong data-v-46d32ae8="" class="text-capitalize">
                    {{ currentUser.first_name }}
                    {{ currentUser.last_name }}</strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
    </mat-toolbar>
    <div class="contentside">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- <router-outlet></router-outlet> -->
